var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"home-logo",attrs:{"src":require("@/assets/logo-color.svg"),"alt":"Li.Re."}})])}]

export { render, staticRenderFns }